import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import { CommonService } from 'src/app/common.service';


@Component({
  selector: 'app-bill-payment-history-detail',
  templateUrl: './bill-payment-history-detail.component.html',
  styleUrls: ['./bill-payment-history-detail.component.scss']
})
export class BillPaymentHistoryDetailComponent implements OnInit {
  paymentInfo:any;
  constructor(
    public commonService:CommonService,
    private _matDialogRef: MatDialogRef<BillPaymentHistoryDetailComponent>,
    @Inject(MAT_DIALOG_DATA) private data: IPopupScreenData
  ) { }

  ngOnInit(): void {
    this.paymentInfo=this.data?.screenData?.data;
  }

}
